import { useNavigate, useLocation, Link } from 'react-router-dom';
import MegaMenu from './MegaMenu';
import MobileMenu from './MobileMenu';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAllTools = location.pathname === '/all-tools';

  return (
    <header className="border-b border-slate-100 bg-white sticky top-0 z-50 transition-colors duration-300">
      <div className="max-w-[1240px] mx-auto px-6 py-3.5 flex items-center justify-between gap-6 relative">
        {/* Logo & Direct navigation (Left block) */}
        <div className="flex items-center gap-8 flex-grow">
          {/* Logo (Far Left) */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 hover:opacity-90 transition-opacity flex-shrink-0 group"
          >
            <div className="flex items-center gap-2">
              <img
                src="/logo.png"
                alt="VibeTools Logo"
                className="w-8 h-8 object-contain"
                width="32"
                height="32"
              />
              <span className="text-xl font-bold text-slate-900 tracking-tight">
                Vibe<span className="text-primary">Tools</span>
              </span>
            </div>
          </button>

          {/* Desktop Navigation (Center/Left) */}
          <nav className="hidden lg:flex items-center gap-1 font-sans">
            <MegaMenu />
            
            <Link
              to="/category/converters-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Converters
            </Link>
            <Link
              to="/category/dev-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Dev Tools
            </Link>
            <Link
              to="/category/text-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Text Tools
            </Link>
            <Link
              to="/category/image-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Image Tools
            </Link>
            <Link
              to="/category/pdf-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              PDF Tools
            </Link>
            <Link
              to="/category/calculator-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Calculators
            </Link>
            <Link
              to="/category/discovery-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Discovery
            </Link>
            <Link
              to="/category/explore-tools"
              className="px-3 py-1.5 text-slate-600 hover:text-slate-900 text-sm font-semibold transition-colors rounded-lg hover:bg-slate-50"
            >
              Explore
            </Link>
          </nav>
        </div>

        {/* Right Side Navigation (Far Right) */}
        <div className="flex items-center gap-4">
          <Link
            to="/all-tools"
            className={`hidden lg:flex items-center justify-center px-5 py-2.5 bg-primary hover:bg-primary/95 text-white transition-all flex-shrink-0 rounded-lg text-sm font-bold shadow-sm active:scale-95`}
            aria-label="Explore Suite"
          >
            Explore Suite
          </Link>

          {/* Mobile Menu (Hamburger - visible on mobile only) */}
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
